const BASE_URL = process.env.REACT_APP_API_URL ?? '';

export const getRankingTable = async (pageIndex, pageSize, sorting, columnFilters) => {
  const url = new URL('/api/ranking', BASE_URL || window.location.origin);
  url.searchParams.set('page', `${pageIndex}`);
  url.searchParams.set('pageSize', `${pageSize}`);
  url.searchParams.set('sorting', JSON.stringify(sorting ?? []));
  url.searchParams.set('filters', JSON.stringify(columnFilters ?? []));

  const response = await fetch(url.href);
  return response.json();
};

export const getRankingHistory = async (jugId) => {
  const url = new URL(`/api/ranking/history/${jugId}`, BASE_URL || window.location.origin);
  const response = await fetch(url.href);
  return response.json();
};

export const getRankingUpdates = async () => {
  const url = new URL('/api/ranking/updates', BASE_URL || window.location.origin);
  const response = await fetch(url.href);
  return response.json();
};

export const getLastRankingFecha = async () => {
  const url = new URL('/api/ranking/last-fecha', BASE_URL || window.location.origin);
  const response = await fetch(url.href);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `HTTP error ${response.status} al consultar última fecha de ranking`);
  }
  return response.json();
};

export const getAvailableTournaments = async (rkgId) => {
  const url = new URL('/api/ranking/available-tournaments', BASE_URL || window.location.origin);
  if (rkgId) url.searchParams.set('rkgId', String(rkgId));
  const response = await fetch(url.href);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `HTTP error ${response.status} al consultar torneos disponibles`);
  }
  return response.json();
};

export const getRankingDetail = async (rkgId) => {
  const url = new URL(`/api/ranking/${rkgId}/detail`, BASE_URL || window.location.origin);
  const response = await fetch(url.href);
  return response.json();
};

export const getRankingFull = async (rkgId) => {
  const url = new URL(`/api/ranking/${rkgId}/full`, BASE_URL || window.location.origin);
  const response = await fetch(url.href);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `HTTP error ${response.status} al obtener el ranking completo`);
  }
  return response.json();
};

export const getRankingLog = async (rkgId) => {
  const url = new URL(`/api/ranking/${rkgId}/log`, BASE_URL || window.location.origin);
  const response = await fetch(url.href);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `HTTP error ${response.status} al obtener el log del ranking`);
  }
  return response.json();
};

export const validarPartidas = async (rkgId) => {
  const url = new URL(`/api/ranking/${rkgId}/validar-partidas`, BASE_URL || window.location.origin);
  const response = await fetch(url.href, { method: 'POST' });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.detail || `HTTP error ${response.status} al validar partidas`);
  }
  return data;
};

export const calcularGrau = async (rkgId) => {
  const url = new URL(`/api/ranking/${rkgId}/calcular-grau`, BASE_URL || window.location.origin);
  const response = await fetch(url.href, { method: 'POST' });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.detail || `HTTP error ${response.status} al calcular GRAU`);
  }
  return data;
};

export const confirmarGrau = async (rkgId) => {
  const url = new URL(`/api/ranking/${rkgId}/confirmar-grau`, BASE_URL || window.location.origin);
  const response = await fetch(url.href, { method: 'POST' });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.detail || `HTTP error ${response.status} al confirmar GRAU`);
  }
  return data; // puede incluir { advertencia } si actualizarJugadoresActivos falló
};


export const createRankingDraft = async (rkg_fecha, tor_ids) => {
  const url = new URL('/api/ranking/draft', BASE_URL || window.location.origin);
  const response = await fetch(url.href, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ rkg_fecha, tor_ids }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'Error al crear el ranking');
  }
  return response.json();
};

export const updateRankingDraft = async (rkgId, rkg_fecha, tor_ids) => {
  const url = new URL(`/api/ranking/${rkgId}/draft`, BASE_URL || window.location.origin);
  const response = await fetch(url.href, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ rkg_fecha, tor_ids }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || 'Error al actualizar el ranking');
  }
};

/**
 * Dispara la descarga del PDF de un reporte para el ranking indicado.
 * Abre la URL en una nueva pestaña; el backend hace streaming del PDF
 * y lo elimina de /tmp una vez enviado.
 *
 * @param {number} rkgId       ID del ranking
 * @param {string} reportName  Valor del enum ReportNames (ej: 'reporte_grau_gral')
 */
export const downloadRankingReport = (rkgId, reportName) => {
  const url = new URL(
    `/api/ranking/${rkgId}/report/${reportName}`,
    BASE_URL || window.location.origin,
  );
  window.open(url.href, '_blank');
};
